import { useApiClient } from '../composables/useApiClient.ts';

export default {
    // by-period forces _invoice_type = manual in the gateway. This path — the one the desktop
    // list uses — returns invoices of every type, automatic ones included.
    index(query: string = '') {
        return useApiClient().get(`bookkeepings/invoices${ query }`);
    },
    delete(id: number) {
        return useApiClient().delete(`bookkeepings/invoices/${ id }`);
    },
    get(id: string) {
        return useApiClient().get(`bookkeepings/invoices/${ id }`);
    },
    // Re-resolves the current contractor, the newest bank account and a fresh currency rate.
    getForDuplicate(id: string) {
        return useApiClient().get(`bookkeepings/invoices/${ id }/for-duplicate`);
    },
    download(id: number) {
        return useApiClient().get(`bookkeepings/invoices/printData/${ id }`);
    },
    downloadDuplicate(id: number) {
        return useApiClient().get(`bookkeepings/invoices/printData/${ id }/duplicate`);
    },
    getInvoiceEmail(id: number) {
        return useApiClient().get(`bookkeepings/invoices/${ id }/email`);
    },
    sendByEmail(id: number) {
        return useApiClient().post(`bookkeepings/invoices/send/${ id }`);
    },
    calculateInvoice (payload) {
        return useApiClient().post(`bookkeepings/invoices/calculate`, { invoice: { ...payload } });
    },
    calculateCorrection (invoiceBeforeCorrectionValues, invoiceAfterCorrectionValues, invoice) {
        return useApiClient().post(`bookkeepings/invoices/calculateCorrectionDifference`, { invoiceBeforeCorrectionValues, invoiceAfterCorrectionValues, invoice });
    },
    storeInvoice (data) {
        return useApiClient().post(`bookkeepings/invoices`, { invoice: { ...data } });
    },
    updateInvoice(id: string, data: any) {
        return useApiClient().put(`bookkeepings/invoices/${ id }`, { invoice: { ...data }});
    },

    // add invoices form
    getInvoiceTypes() {
        return useApiClient().get(`bookkeepings/invoice_type?list`);
    },
    getInvoiceNumberTemplates(invoiceType: number) {
        return useApiClient().get(`bookkeepings/invoice_number_template/${invoiceType}?list`);
    },
    getInvoiceNumber(numberTemplateId: number, issueDate: string) {
        return useApiClient().get(`bookkeepings/invoice_number/${numberTemplateId}/${issueDate}`);
    },
    getLinkedInvoices(id) {
        return useApiClient().get(`bookkeepings/invoices/linked/${id}`);
    },
    getAdvanceValue(id) {
        return useApiClient().get(`bookkeepings/invoices/calculate/advance/${id}`);
    },

    // templates
    getVatRegisterTypes() {
        return useApiClient().get(`bookkeepings/vat-register-types?list=true`);
    },
    getDescriptionTemplates() {
        return useApiClient().get(`bookkeepings/invoice-description-templates/?list=true`);
    },
    addInvoiceTemplate(payload) {
        return useApiClient().post(`bookkeepings/invoice-description-templates/`, {
            invoicedescriptiontemplate: { ...payload } });
    },
    getRyczaltRates() {
        return useApiClient().get(`bookkeepings/ryczalt/rates`);
    },
    getKpirColumns() {
        return useApiClient().get(`bookkeepings/kpir/columns`);
    },
    calculate(templateData) {
        return useApiClient().post(`bookkeepings/invoice-description-templates/calculate`, {
            ...templateData
        });
    },
    getCurrencies() {
        return useApiClient().get(`currency`);
    },
    getCurrencyData(currencyID: string, currencyDate: string) {
        return useApiClient().get(`currency/${currencyID}?date=${currencyDate}`);
    },
    submitToKsef(invoiceId: number) {
        return useApiClient().post(`bookkeepings/ksef/invoices/submit-bulk`, { invoice_ids: [invoiceId] });
    },
    submitToKsefBulk(invoiceIds: number[]) {
        return useApiClient().post(`bookkeepings/ksef/invoices/submit-bulk`, { invoice_ids: invoiceIds });
    },
    getUpoUrl(invoiceOriginal: number) {
        return useApiClient().get(`bookkeepings/ksef/invoices/${invoiceOriginal}/upo-pdf`);
    },
    downloadFa3(invoiceOriginal: number) {
        return useApiClient().get(`bookkeepings/ksef/invoices/${invoiceOriginal}/artifacts/fa3`, { responseType: 'blob' });
    },
};
